<template>
  <div class="lpForm">
    <div class="lpForm__title">必要情報を入力</div>
    <form :action="`/2022_luck/complete/${ menu.menu_id }`" method="POST">
      <input type="hidden" name="_token" :value="csrfToken" />
      <formBirthday
        name="birthday"
        type="tel"
        :value="myBirthdayMod"
        :label="''"
        :placeholder-year="'2000'"
        :placeholder-month="'01'"
        :placeholder-day="'01'"
        @change="onTargetDateChange"
        :validation="{ rules: {
            required: true,
            regex: /[12][0-9]{3}([1][0-2]|[0][1-9])(0[1-9]|[12][0-9]|3[01])/,
            birthRange: true,
            max: 8,
            min: 8,
            } }"
      />
      <formNickname
        :value="nicknameValue"
        @input="onNicknameChange"
      />
      <form-radio
        v-if="isKurenotori"
        name="gender"
        v-model="gender"
        :options="FORM_OPTIONS.gender"
      />
      <div
        class="lpForm__submit"
        @click="onSubmit"
        :disabled="isSubmitDisable"
      >{{ this.btnText }}</div>
    </form>
  </div>
</template>

<script>
import { FORM_OPTIONS } from '@/CONSTS'
import formBirthday from "./formBirthday";
import formNickname from "./formNickname";
import formRadio from "./formRadio";

export default {
  name: "lpForm",
  components: {
    formBirthday,
    formNickname,
    formRadio,
  },
  props: {
    menu: {
      type: Object,
      default () {
        return {}
      }
    },
    csrfToken: {
      type: String,
      default() {
        return ''
      }
    },
    myNickname: {
      type: String,
      default() {
        return ''
      }
    },
    myBirthday: {
      type: String,
      default() {
        return ''
      }
    },
    myGender: {
      type: String,
      default: '',
    },
    subscriptionFlg: Boolean,
    isHoshiHitomi: Boolean,
  },
  data() {
    return {
      FORM_OPTIONS,
      isSubmitDisable: false,
      tgtBirthCheck: false,
      tgtNicknameCheck: false,
      gender: this.myGender,
      nicknameValue: '',
      lock: false,
      btnText: "購入へ進む (月額会員は¥0)",
      isKurenotori: this.menu.menu_id == '6203'
    }
  },
  computed: {
    myBirthdayMod() {
      let bd = this.myBirthday
      let y, m, d
      if(/^\d{4}-\d{2}-\d{2}$/.test(bd)) {
        [ y, m, d ] = bd.split('-').map(item => parseInt(item))
        this.tgtBirthCheck = true
      } else if(/^\d{8}$/.test(bd)) { //そのまま返してもいいけど一旦分ける
        y = parseInt(bd.substr(0,4))
        m = parseInt(bd.substr(4,2))
        d = parseInt(bd.substr(6,2))
        this.tgtBirthCheck = true
      }
      if(this.$el != null) {
        this.checkCanSubmit()
      }
      const result = bd ? [y, ('0' + m).slice(-2), ('0' + d).slice(-2)].join('') : ''
      return result
    },
  },
  mounted() {
    if(this.myNickname != null && this.myNickname.length > 0){
      this.nicknameValue = this.myNickname
    }
    setTimeout(() => this.checkCanSubmit(),100)
    if (this.isHoshiHitomi) {
      this.btnText = "購入へ進む"
    } else if (this.subscriptionFlg != false) {
      this.btnText = "2022年下半期の運勢を見る"
    }
  },
  watch: {
    gender() {
      this.checkCanSubmit()
    },
  },
  methods: {
    onTargetDateChange(birth, err) {
      // console.log('BirthCheck: birth->%s err:%O', birth, err)
      this.tgtBirthCheck = !err
      this.checkCanSubmit()
    },
    onNicknameChange(value) {
      this.nicknameValue = value
      this.checkCanSubmit()
    },
    checkCanSubmit() {
      if(this.$el != null && typeof this.$el.querySelector !== undefined) {
        this.tgtNicknameCheck = /^.{1,8}$/.test(this.nicknameValue)
        // console.log('nickname:%s birth:%s', this.tgtNicknameCheck, this.tgtBirthCheck)

        // 暮れの酉なら gender チェック、それ以外は常に true
        const genderCheck = this.isKurenotori ? !!this.gender : true

        if (this.tgtBirthCheck && this.tgtNicknameCheck && genderCheck) {
          this.isSubmitDisable = false
        } else {
          this.isSubmitDisable = true
        }
      }
    },
    onSubmit() {
      if(!this.lock) {
        this.lock = true
        this.checkCanSubmit()
        if(!this.isSubmitDisable){
          this.isSubmitDisable = true
          this.$el.querySelector('form').submit()
        } else {
          this.lock = false
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.lpForm {
  max-width: 500px;
  margin: 0 auto;
  padding: 40px 30px 0;
  &__title {
    text-align: center;
    font-weight: bold;
    font-size: 24px;
    line-height: 1;
    color: #32373F;
    margin: 0 -10px 40px;
  }
  &__submit {
    background: #412E2E;
    border: 2px solid #412E2E;
    border-radius: 35px;
    padding: 15px;
    font-weight: bold;
    font-size: 14px;
    line-height: 21px;
    color: #FFFFFF;
    text-align: center;
    margin: 40px auto 0;
    transition: 0.2s;
    cursor: pointer;
    &[disabled] {
      color: #DCDFE2;
      background: #FFFFFF;
      border-color: #DCDFE2;
      pointer-events: none;
      cursor: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/YearLuck/y2022/lpForm.vue